import { CLEAR_REDIRECT, SET_REDIRECT } from './actions';

export const setRedirect = (name: string, params: any) => ({
    type: SET_REDIRECT,
    name, params
});

export const clearRedirect = () => ({
    type: CLEAR_REDIRECT
});